// extracted by mini-css-extract-plugin
export var page404Title = "MemberPanel-module--page404-title--2sBna";
export var memberPanel = "MemberPanel-module--memberPanel--2RasH";
export var breadCrumb = "MemberPanel-module--breadCrumb--2-HD-";
export var photoWrap = "MemberPanel-module--photoWrap--2VZj2";
export var photo = "MemberPanel-module--photo--3s7tG";
export var copy = "MemberPanel-module--copy--DLh8l";